import { CcofPatientDetails } from "lib/api-types/schemas";
import { Patient } from "../types";

const patientToPatientDetailsAdapter = (
  patient: Patient,
): CcofPatientDetails => ({
  patientId: patient.patientId,
  practiceId: patient.practiceId,
  firstName: patient.firstName,
  middleName: patient.middleName,
  lastName: patient.lastName,
  dateOfBirth: patient.dateOfBirth,
  mrn: patient.mrn,
  phoneNumber: patient.phone,
  address: patient.address,
  cardOnFile: patient.cardOnFile ?? undefined,
  cardCapture: patient.cardCapture
    ? {
        sessionId: patient.cardCapture.sessionId ?? undefined,
        state: patient.cardCapture.state,
      }
    : undefined,
});

export default patientToPatientDetailsAdapter;
